import { numberToStringDecoder, stringToNumberDecoder } from '@execonline-inc/decoders';
import { identity } from '@kofno/piper';
import { Decoder, array, field, number, string, succeed } from 'jsonous';
import {
  NumberOption,
  NumberOptions,
  Option,
  StringOption,
  StringOptions,
  ToString,
} from './Types';

export const optionDecoder = <T extends ToString>(decoder: Decoder<T>): Decoder<Option<T>> =>
  succeed({})
    .assign('label', field('label', string))
    .assign('value', field('value', decoder))
    .map<Option<T>>(identity);

export const stringOptionDecoder: Decoder<StringOption> = optionDecoder(string);

export const stringOptionsDecoder: Decoder<StringOptions> = array(stringOptionDecoder);

export const numberOptionDecoder: Decoder<NumberOption> = optionDecoder(number);

export const numberOptionsDecoder: Decoder<NumberOptions> = array(numberOptionDecoder);

export const stringToNumberOptionDecoder: Decoder<NumberOption> =
  optionDecoder(stringToNumberDecoder);

export const stringToNumberOptionsDecoder: Decoder<NumberOptions> = array(
  stringToNumberOptionDecoder,
);

export const numberToStringOptionDecoder: Decoder<StringOption> =
  optionDecoder(numberToStringDecoder);

export const numberToStringOptionsDecoder: Decoder<StringOptions> = array(
  numberToStringOptionDecoder,
);
